  document.querySelectorAll('div[data-faq-contact]').forEach((item, index) => {
        const faqItem = document.querySelectorAll('.faq-item.featured')[index];
        
      
        item.querySelector('.faq-question .ques').textContent = faqItem.querySelector(".faq-question").textContent;
      item.querySelector('.faq-answer.auns').innerHTML = faqItem.querySelector(".faq-answer").innerHTML;
      }
    );

      document.querySelectorAll('div[data-faq-perks]').forEach((item, index) => {
        const faqItem = document.querySelectorAll('.faq-item.perks')[index];
        
      
        item.querySelector('.faq-question .ques').textContent = faqItem?.querySelector(".faq-question").textContent;
      item.querySelector('.faq-answer.auns').innerHTML = faqItem.querySelector(".faq-answer").innerHTML;
      }
    );